module.exports = __webpack_public_path__ + "static/media/derrick_kyle_suarez_resume_pdf.c44c2905.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/derrick_kyle_suarez_resume_pdf.pdf
// module id = 31
// module chunks = 0